export default (propsToMap = []) => ({
    created() {
        // If present, prepopulate component data from a matching props obj.
        propsToMap.forEach((propHandle) => {
            Object.keys(this[propHandle]).forEach((key) => {
                this[key] = this[propHandle][key];
            });
        });
    }
});
